import en from "./en.json";
import ko from "./ko.json";

export default {
  en,
  ko,
};
